import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getAllPaidUsers, getFreeUser, getPaidUser } from '../../api/paidUsers';
import { BASE_URL_MAIN_SERVER } from '../../helpers/constants.js';
import { updateSupport } from '../../api/customerSupportApi.js';
import { getAllFreeUsers } from '../../api/freeUsers.js';

export const getDialogue = createAsyncThunk(
  'liveChat/getDialogue',
  async (userData, thunkAPI) => {
    const END_POINT = '/dialogue';
    const url = BASE_URL_MAIN_SERVER + END_POINT;
    const params = {
      userId: userData.userId,
      userType: userData.userType,
    };

    try {
      const response = await axios.get(url, { params });
      const dialogueUsers = await getDialogueUsers(
        response.data,
        userData.userType,
      );
      return {
        data: response.data,
        dialogueUsers,
      };
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const getSessions = createAsyncThunk(
  'liveChat/getSessions',
  async (userData, thunkAPI) => {
    const END_POINT = '/dialogue';
    const url = BASE_URL_MAIN_SERVER + END_POINT;
    const params = {
      userId: userData.userId,
      userType: userData.userType,
    };

    try {
      const response = await axios.get(url, { params });
      const dialogues = response.data;
      const preSessions = [];
      for (const el of dialogues) {
        preSessions.push({
          chatId: el._id,
          counter: 60,
          freeUserId: el.freeUserId,
        });
      }

      const sessions = {};
      preSessions.forEach(el => {
        sessions[el.chatId] = el;
      });
      return sessions;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
export const createDialogue = createAsyncThunk(
  'liveChat/createDialogue',
  async (userData, thunkAPI) => {
    const END_POINT = '/dialogue';
    const url = BASE_URL_MAIN_SERVER + END_POINT;

    try {
      const response = await axios.post(url, userData);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

const getDialogueUsers = async (dialogue, userType) => {
  if (userType === 'freeUser') {
    const idList = dialogue.map(el => el.paidUserId);
    const response = await getAllPaidUsers({
      usersIds: idList,
      perPage: 10000,
    });
    return response.users;
  } else {
    const idList = dialogue.map(el => el.freeUserId);
    const response = await getAllFreeUsers({
      usersIds: idList,
      perPage: 10000,
    });
    return response.users;
  }
};

export const getMessages = createAsyncThunk(
  'LiveChat/getMessages',
  async (userData, thunkAPI) => {
    const END_POINT = '/messages';
    const url = BASE_URL_MAIN_SERVER + END_POINT;
    const params = {
      chatId: userData.chatId,
      perPage: 10,
      page: userData.page,
    };

    try {
      const response = await axios.get(url, { params });

      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
export const updateDialogue = createAsyncThunk(
  'LiveChat/updateDialogue',
  async ({ id, ...data }, thunkAPI) => {
    const END_POINT = `/dialogue/${id}`;
    const url = BASE_URL_MAIN_SERVER + END_POINT;

    try {
      const response = await axios.put(url, data);

      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const updateSupportDialogue = createAsyncThunk(
  'LiveChat/updateSupportDialogue',
  async ({ id, ...data }, thunkAPI) => {
    try {
      return await updateSupport(id, data);
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
